import { render, staticRenderFns } from "./OffsetTemp.vue?vue&type=template&id=6f639eb0"
import script from "./OffsetTemp.vue?vue&type=script&lang=js"
export * from "./OffsetTemp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports